import React from "react";
import styled from 'styled-components';
import { Card, Heading } from "../../Components/StyledComponents/StyledComponents";

const Root = styled.div`
width:100%;
overflow-x: auto;
margin-bottom:${(p) => p.theme.spacing.sm};

::-webkit-scrollbar{
  width:4px;
  height:3px;

}
::-webkit-scrollbar-thumb{
background-color:${(p) => p.theme.colors.darkvioletColor};
border-radius:4px;
}
`;
const HeadingWrapper = styled.div`
background-color:${(p) => p.theme.colors.lightvoiletColor};
display:flex;
align-items:center;
justify-content:space-between;
padding:${(p) => p.theme.spacing.xs};
border-radius:${(p) => p.theme.radius.xl};
margin-bottom:${(p) => p.theme.spacing.xs};
`;
const DataWrapper = styled.div`
display:flex;
align-items:center;
justify-content:space-between;
padding:${(p) => p.theme.spacing.xs};
`;
const Data = styled.div`
flex:1;
font-size:${(p) => p.theme.font.size.xs};
@media(min-width:1600px){
  font-size:${(p) => p.theme.font.size.md};
}
`;

const HeaderText = styled.div`
flex:1;
font-size:${(p) => p.theme.font.size.xs};
font-weight:${(p) => p.theme.font.weight.bold};
@media(min-width:1600px){
  font-size:${(p) => p.theme.font.size.md};
}
`;


const BidHistory = ({ nft }) => {
  return (
    <Root>
      <Heading bottom="sm">BID HISTORY</Heading>
      <Card width="700px">
        <HeadingWrapper>
          <HeaderText>Address</HeaderText>
          <HeaderText>Hash</HeaderText>
          <HeaderText>Action Price(META)</HeaderText>
          <HeaderText>Action Time</HeaderText>
          <HeaderText>Profits</HeaderText>
          <HeaderText>Status</HeaderText>
        </HeadingWrapper>
        <DataWrapper>
          <Data>{nft.ownerAddress.slice(0, 6)}...{nft.ownerAddress.slice(-4)}</Data>
          <Data>{nft.hash.slice(0, 6)}...{nft.hash.slice(-4)}</Data>
          <Data>100,000</Data>
          <Data>Apr 5,2022,11:30</Data>
          <Data>-</Data>
          <Data>-</Data>
        </DataWrapper>
      </Card>
    </Root>
  );
};

export default BidHistory;